import { CUSTOM_ELEMENTS_SCHEMA, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';

import { VehicleService } from '../vdms_core/services/api/vehicle.service';

import { Observable, from, of } from 'rxjs';
import { ListVehicleMastersModel } from '../vdms_core/model/vehicle.model';
import { Router } from '@angular/router';
import { UserService } from '../vdms_core/services/api/user.services';
import { ExcelFileDownloadServices } from '../vdms_shared/utils/excelDownload.services';
import { StringToDateAndRenewalPipe } from '../vdms_shared/pipes/renewal.status';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { AwsS3BucketService } from '../vdms_core/services/awsS3Bucket/aws-s3-bucket.service';
import * as JSZip from 'jszip';
import * as XLSX from 'xlsx';
import { VendorService } from '../vdms_core/services/api/vendor.service';

@Component({
  selector: 'app-vdms-tabs',
  templateUrl: './vdms-tabs.component.html',
  styleUrls: ["./vdms-tabs.component.css"],
})
export class VdmsTabsComponent implements OnInit, OnDestroy {
  receivedUnAssignedVehicleData: ListVehicleMastersModel;
  receivedVIPData: ListVehicleMastersModel;
  receivedSurrenderedData: ListVehicleMastersModel;
  receivedAssignVehicleData: any;

  currentStatusIndex: any;
  vehicleData: any;
  daVehicleData: any;

  defaultvehicleStatus = { index: 0, name: 'live cars' };

  unAssignedCarData: any;
  assignedCarData: any;
  surrenderedData: any
  vipData: any

  receivedAllVehicleRecord: any

  cpAssignedCarRecord: any
  userTypeRecord: any;
  getDriverTypeRecord: any
  pagenationNextToken = "";
  isnextBtn: boolean = false;
  splitRecords: {}

  public isDropdownOpen = false;
  private clickListener: () => void;

  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  @ViewChild('viewmodalExample') viewModal: ElementRef;

  viewDetails: any = [];
  tabName: any;

  constructor(
    public vehicleService: VehicleService,
    public router: Router,
    public userService: UserService,
    public excelFileDownloadServices: ExcelFileDownloadServices,
    private stringToDateAndRenewalPipe: StringToDateAndRenewalPipe,
    private spinnerService: Ng4LoadingSpinnerService,
    private renderer: Renderer2,
    private awsS3BucketService: AwsS3BucketService,
    public vendorService: VendorService,
  ) {
    // this.CheckStatus(this.defaultvehicleStatus);

  }

  ngOnInit() {
    this.getCpAssignedCars();
  }

  // Clean up the listener when the component is destroyed
  ngOnDestroy() {
    this.removeClickOutsideListener();
  }

  async getCpAssignedCars() {
    // alert('carRequest' + this.carReqlist.length)
    const limit = 100;  // Set the limit for records per request
    let nextToken: string = null;  // Start with null for the first page
    this.cpAssignedCarRecord = []// Initialize tempData to store fetched data
    this.spinnerService.show();  // Show spinner while loading data

    try {
      // Loop until nextToken becomes null (no more pages)
      do {
        // Fetch data from API, starting with null nextToken for the first page
        const data = (await this.vehicleService.getCpAssignedCar(nextToken, limit));


        // Append the fetched records to tempData
        this.cpAssignedCarRecord = [...this.cpAssignedCarRecord, ...data.items];

        // Update nextToken for the next iteration (will be null if no more pages)
        nextToken = data.nextToken;

      } while (nextToken !== null);  // Continue as long as there's a nextToken


      // After fetching all records, process the data
      // After fetching all records, process the data
      this.sortRecordsByAssignedCars();
      // this.getAllVehicle()

    } catch (error) {
      console.error("Error fetching data:", error);
      this.spinnerService.hide();
    } finally {
      // this.spinnerService.hide();  // Hide the spinner after the process
    }

    if (this.pagenationNextToken == null) {
      this.isnextBtn = true;
    }
  }

  sortRecordsByAssignedCars() {

    var statusArray = ['ASSIGN', 'UNASSIGN', 'VIP', 'SURRENDER'];

    // Initialize an object to hold arrays for each status
    // Initialize the object to hold arrays for each status
    const splitRecords = {};

    // Initialize each status in splitRecords with an empty array
    for (const status of statusArray) {
      splitRecords[status] = []; // Create an empty array for each status
    }

    // Categorize vehicles based on ex_data
    for (const vehicle of this.cpAssignedCarRecord) {
      if (splitRecords[vehicle.status]) {
        splitRecords[vehicle.status].push(vehicle); // Push vehicle into the corresponding status array
      }
    }

    // Store specific records for "ASSIGN" and "UNASSIGN"

    this.assignedCarData = splitRecords['ASSIGN'] || [];
    // this.unAssignedCarData = splitRecords['UNASSIGN'] || [];
    // this.surrenderedData = splitRecords['SURRENDER'] || [];
    // this.vipData = splitRecords['VIP'] || [];

    this.getAllVehicle()
    // if (this.assignedCarData.length > 0) {
    //   this.getAllVehicle()
    //   // this.getDaVehicleMaster();
    // }

    // this.spinnerService.hide();

    // return splitRecords;

  }

  async getAllVehicle() {
    // alert('carRequest' + this.carReqlist.length)
    const limit = 100;  // Set the limit for records per request
    let nextToken: string = null;  // Start with null for the first page
    this.receivedAllVehicleRecord = []// Initialize tempData to store fetched data
    // this.spinnerService.show();  // Show spinner while loading data

    try {
      // Loop until nextToken becomes null (no more pages)
      do {
        // Fetch data from API, starting with null nextToken for the first page
        const data = (await this.vehicleService.getAllVehicleMaster(nextToken, limit));

        // Append the fetched records to tempData
        this.receivedAllVehicleRecord = [...this.receivedAllVehicleRecord, ...data.items];

        // Update nextToken for the next iteration (will be null if no more pages)
        nextToken = data.nextToken;

      } while (nextToken !== null);  // Continue as long as there's a nextToken


      // After fetching all records, process the data
      // After fetching all records, process the data
      this.splitRecordsByStatus();


    } catch (error) {
      console.error("Error fetching data:", error);
      this.spinnerService.hide();
    } finally {
      // this.spinnerService.hide();  // Hide the spinner after the process
    }

    if (this.pagenationNextToken == null) {
      this.isnextBtn = true;
    }
  }



  splitRecordsByStatus() {

    var statusArray = ['ASSIGN', 'UNASSIGN', 'VIP', 'SURRENDER'];

    // Initialize an object to hold arrays for each status
    // Initialize the object to hold arrays for each status
    const splitRecords = {};

    // Initialize each status in splitRecords with an empty array
    for (const status of statusArray) {
      splitRecords[status] = []; // Create an empty array for each status
    }

    // Categorize vehicles based on ex_data
    for (let vehicle of this.receivedAllVehicleRecord) {
      if (splitRecords[vehicle.ex_data] && (vehicle.car_type.toLowerCase() != "vip" && vehicle.ex_data != 'ASSIGN')) {
        vehicle["agencyName"] = vehicle.agency.name;
        splitRecords[vehicle.ex_data].push(vehicle); // Push vehicle into the corresponding status array
      } else if(splitRecords[vehicle.car_type.toUpperCase()] && (vehicle.car_type.toLowerCase() == "vip" && vehicle.ex_data == 'ASSIGN')) {
        vehicle["agencyName"] = vehicle.agency.name;
        splitRecords[vehicle.car_type.toUpperCase()].push(vehicle); 
      }
    }

    // Store specific records for "ASSIGN" and "UNASSIGN"

    // this.assignedCarData = splitRecords['ASSIGN'] || [];
    this.unAssignedCarData = splitRecords['UNASSIGN'] || [];
    this.surrenderedData = splitRecords['SURRENDER'] || [];
    this.vipData = splitRecords['VIP'] || [];


    if (this.assignedCarData.length > 0) {
      this.getDaVehicleMaster();
      // this.getUserType();
    } else {
      this.constructCombinedVehicleData();
      // this.spinnerService.hide();
    }

    return splitRecords;

  }

  // public CheckStatus(vehicleStatus: any) {
  //   let setStatus: any = '';
  //   var statusArray = ['ASSIGN', 'UNASSIGN', 'VIP', 'SURRENDER'];

  //   const getArrayIndex = statusArray.findIndex(
  //     (element, index) => index === vehicleStatus.index
  //   );

  //   if (getArrayIndex !== -1) {
  //     console.log('Index of array value:', getArrayIndex);
  //     console.log('Value in the array:', statusArray[getArrayIndex]);
  //     setStatus = statusArray[getArrayIndex];
  //     this.currentStatusIndex = getArrayIndex;
  //     this.getVehicleData(setStatus);
  //   } else {
  //     console.log('Index not found.');
  //   }
  // }
  // public async getVehicleData(vehicleStatus: any) {
  //   console.log('Tab clicked:', vehicleStatus);

  //   this.vehicleData = ''

  //   try {
  //     const assignedVehicle: any = await this.vehicleService.filterByStatus(
  //       vehicleStatus
  //     ); // Assuming getVendorDataFromDatabase() returns a Promise<VendorModel>
  //     console.log('TAB_RENDER', assignedVehicle);

  //     if (this.currentStatusIndex !== 0) {
  //       this.vehicleData = assignedVehicle.items
  //     } else {
  //       this.vehicleData = assignedVehicle

  //       if (this.vehicleData.items.length > 0) {
  //         this.getDaVehicleMaster();
  //       }
  //     }

  //     console.log('unAssignedCarData', this.vehicleData);
  //     return this.vehicleData
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }

  navigateToNewVehicle() {
    this.router.navigate(['pages/addVehicle']);
  }

  async getDaVehicleMaster() {
    try {
      this.daVehicleData = await this.vehicleService.getDaVehicleMaster(); // Assuming getVendorDataFromDatabase() returns a Promise<VendorModel>
      // if (this.daVehicleData.items.length > 0) {
      //   this.getUserType();
      // }

      //this.daVehicleData = assignedVehicle.items;
      this.constructCombinedVehicleData();
    } catch (error) {
      console.error('Error fetching data:', error);
      this.spinnerService.hide();
    }
  }

  // async getUserType() {
  //   try {
  //     this.userTypeData = await this.userService.filterByUserType(); // Assuming getVendorDataFromDatabase() returns a Promise<VendorModel>
  //     // this.sendDataToParent(this.currentStatusIndex, '');

  //     if (this.userTypeData.items.length > 0) {
  //       this.constructAssignedVehicleData();
  //       this.spinnerService.hide();
  //     }

  //     //this.daVehicleData = userType.items;
  //     // this.assignedCarData.paginator = this.paginator;
  //     //console.log('USER_TYPE', this.daVehicleData);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }

  //   async getUserType() {
  //     console.log("Fetching user type data...");
  //     this.userTypeData = []; // Initialize userTypeData to store fetched data
  //     this.spinnerService.show(); // Show spinner while loading data

  //     try {
  //         // Fetch all data from API in a single request
  //         const data = await this.userService.filterByUserType();
  //         console.log("Fetched Data:", data);

  //         // Store fetched records in userTypeData
  //         this.userTypeData = data.items;
  //         console.log(`Total records fetched: ${this.userTypeData.length}`);

  //         // Process the data if records were fetched
  //         if (this.userTypeData.length > 0) {
  //             this.constructAssignedVehicleData();
  //         }

  //     } catch (error) {
  //         console.error("Error fetching data:", error);
  //     } finally {
  //         this.spinnerService.hide(); // Hide the spinner after the process
  //     }

  //     // Set next button state to disable pagination since it's a single request
  //     this.isnextBtn = true;
  // }


  async getUserType() {
    // alert('carRequest' + this.carReqlist.length)
    const limit = 100;  // Set the limit for records per request
    let nextToken: String = null;  // Start with null for the first page
    this.userTypeRecord = []// Initialize tempData to store fetched data
    // this.spinnerService.show();  // Show spinner while loading data

    try {
      // Loop until nextToken becomes null (no more pages)
      do {
        // Fetch data from API, starting with null nextToken for the first page
        const data = (await this.userService.filterByUserType(nextToken, limit, 6));

        // // Append the fetched records to tempData
        this.userTypeRecord = [...this.userTypeRecord, ...data.items];

        // Update nextToken for the next iteration (will be null if no more pages)
        nextToken = data.nextToken;

      } while (nextToken !== null);  // Continue as long as there's a nextToken


      // After fetching all records, process the data
      // After fetching all records, process the data
      // this.splitRecordsByStatus();

      if (this.userTypeRecord.length > 0) {
        // this.spinnerService.hide();
        this.getDriverType();
      } else {
        this.spinnerService.hide();
      }


    } catch (error) {
      console.error("Error fetching data:", error);
      this.spinnerService.hide();
    } finally {
      // this.spinnerService.hide();  // Hide the spinner after the process
    }

    if (this.pagenationNextToken == null) {
      this.isnextBtn = true;
    }
  }

  async getDriverType() {
    // alert('carRequest' + this.carReqlist.length)
    const limit = 100;  // Set the limit for records per request
    let nextToken: String = null;  // Start with null for the first page
    this.getDriverTypeRecord = []// Initialize tempData to store fetched data
    this.spinnerService.show();  // Show spinner while loading data

    try {
      // Loop until nextToken becomes null (no more pages)
      do {
        // Fetch data from API, starting with null nextToken for the first page
        const data = (await this.userService.filterByUserType(nextToken, limit, 3));

        // // Append the fetched records to tempData
        this.getDriverTypeRecord = [...this.getDriverTypeRecord, ...data.items];

        // Update nextToken for the next iteration (will be null if no more pages)
        nextToken = data.nextToken;

      } while (nextToken !== null);  // Continue as long as there's a nextToken


      // After fetching all records, process the data
      // After fetching all records, process the data
      // this.splitRecordsByStatus();

      if (this.getDriverTypeRecord.length > 0) {
        // this.spinnerService.hide();
        this.constructCombinedVehicleData();
      } else {
        this.spinnerService.hide();
      }


    } catch (error) {
      console.error("Error fetching data:", error);
      this.spinnerService.hide();
    } finally {
      // this.spinnerService.hide();  // Hide the spinner after the process
    }

    if (this.pagenationNextToken == null) {
      this.isnextBtn = true;
    }
  }



  // constructAssignedVehicleData() {
  //   console.log('USER_TYPE', this.userTypeData);

  //   // Filter cpAssignedCarRecord to include only records with status 'ASSIGN'
  //   const ca = this.cpAssignedCarRecord.filter(record => record.status === 'ASSIGN');
  //   const vh = this.receivedAllVehicleRecord; // All vehicle records
  //   const us = this.userTypeData;             // User type data

  //   console.log('us', this.userTypeData)
  //   // Array to hold the final constructed records
  //   const finalData = [];

  //   for (let i = 0; i < ca.length; i++) {
  //     // Clone the current record to avoid modifying the original
  //     let currentRecord = { ...ca[i] };

  //     // Find the matching vehicle in vh based on car_id
  //     const matchedVehicle = vh.find(vehicle => vehicle.id === currentRecord['car_id']);
  //     if (matchedVehicle) {
  //       // Merge matched vehicle data into the cloned record
  //       currentRecord = { ...currentRecord, ...matchedVehicle };
  //       console.log(`Matched Vehicle for ca[${i}]:`, matchedVehicle);
  //       console.log(`Matched Vehicle for ca2[${i}]:`, currentRecord);
  //     }

  //     // Find the matching user in us based on user_pid
  //     const matchedUser = us.find(user => user.id === currentRecord['user_pid']);
  //     if (matchedUser) {
  //       // Add driver details to the cloned record
  //       currentRecord['driver_mobile'] = matchedUser['user_name'];
  //       currentRecord['driver_name'] = matchedUser['name'];
  //       console.log(`Matched User for ua[${i}]:`, matchedUser);
  //     }

  //     // Add the modified record to finalData
  //     finalData.push(currentRecord);
  //   }

  //   // Store the final constructed data in receivedAssignVehicleData
  //   console.log('Final_constructed_data:', finalData);
  //   this.receivedAssignVehicleData = finalData;
  // }



  //   constructAssignedVehicleData() {
  //     console.log('USER_TYPE', this.userTypeData);

  //     // Filter cpAssignedCarRecord to include only records with status 'ASSIGN'
  //     const ca = this.cpAssignedCarRecord.filter(record => record.status === 'ASSIGN');
  //     const vh = this.receivedAllVehicleRecord; // All vehicle records
  //     const us = this.userTypeData;             // User type data

  //     for (let i = 0; i < ca.length; i++) {
  //         // Find the matching vehicle in vh based on car_id
  //         const matchedVehicle = vh.find(vehicle => vehicle.id === ca[i]['car_id']);
  //         if (matchedVehicle) {
  //             // Merge matched vehicle data into ca[i]
  //             ca[i] = { ...ca[i], ...matchedVehicle };
  //         }

  //         // Find the matching user in us based on user_pid
  //         const matchedUser = us.find(user => user.id === ca[i]['user_pid']);
  //         if (matchedUser) {
  //             // Add driver details to ca[i]
  //             ca[i]['driver_mobile'] = matchedUser['user_name'];
  //             ca[i]['driver_name'] = matchedUser['name'];
  //         }
  //     }

  //     console.log('Final_constructed_data', ca);
  //     this.receivedAssignVehicleData = ca; // Store the final constructed data
  // }


  //   constructAssignedVehicleData() {
  //     console.log('USER_TYPE', this.userTypeData);

  //     const ca = this.cpAssignedCarRecord;      // Assigned car records
  //     const vh = this.receivedAllVehicleRecord; // All vehicle records
  //     const us = this.userTypeData;             // User type data

  //     for (let i = 0; i < ca.length; i++) {
  //         // Find the matching vehicle in vh based on car_id
  //         const matchedVehicle = vh.find(vehicle => vehicle.id === ca[i]['car_id']);
  //         if (matchedVehicle) {
  //             // Merge matched vehicle data into ca[i]
  //             ca[i] = { ...ca[i], ...matchedVehicle };
  //         }

  //         // Find the matching user in us based on user_pid
  //         const matchedUser = us.find(user => user.id === ca[i]['user_pid']);
  //         if (matchedUser) {
  //             // Add driver details to ca[i]
  //             ca[i]['driver_mobile'] = matchedUser['user_name'];
  //             ca[i]['driver_name'] = matchedUser['name'];
  //         }
  //     }

  //     console.log('Final_constructed_data', ca);
  //     this.receivedAssignVehicleData = ca; // Store the final constructed data
  // }

  // REMOVE  const da = this.daVehicleData.items;
  // ca [car_id] == vh[id] compare get record vh store it ca based on index
  // ca [user_pid] == us[id]compare get record vh store it ca based on index


  // constructAssignedVehicleData() {
  //   console.log('DA_vehicle_master', this.daVehicleData.items);
  //   console.log('USER_TYPE', this.userTypeData);

  //   const ca = this.cpAssignedCarRecord;      // Assigned car records
  //   const vh = this.receivedAllVehicleRecord; // All vehicle records
  //   const da = this.daVehicleData.items;      // Vehicle master data
  //   const us = this.userTypeData;             // User type data

  //   alert('driver' + da.length);
  //   alert('user' + us.length);

  //   for (let i = 0; i < ca.length; i++) {
  //     for (let j = 0; j < da.length; j++) {
  //       // Check if car IDs match between ca and vh
  //       if (ca[i]['car_id'] === vh[j]['id']) {
  //         // Store all properties of vh[j] in ca[i]
  //         ca[i] = { ...ca[i], ...vh[j] };

  //         for (let k = 0; k < us.length; k++) {
  //           // Check if user IDs match between da and us
  //           if (ca[i]['car_id'] === us[k]['id']) {
  //             // Add driver details to ca[i]
  //             ca[i]['driver_mobile'] = us[k]['user_name'];
  //             ca[i]['driver_name'] = us[k]['name'];
  //             break; // Stop searching in us once match is found
  //           }
  //         }
  //         break; // Stop searching in da once match is found
  //       }
  //     }
  //   }

  //   console.log('Final_constructed_data', ca);
  //   this.receivedAssignVehicleData = ca; // Store the final constructed data
  // }
  // constructCombinedVehicleData() {
  //   console.log('USER_TYPE', this.userTypeData);
  //   console.log('DA_vehicle_master', this.daVehicleData.items);

  //   // Step 1: Filter cpAssignedCarRecord to include only records with status 'ASSIGN'
  //   const ca = this.cpAssignedCarRecord.filter(record => record.status === 'ASSIGN');
  //   const vh = this.receivedAllVehicleRecord; // All vehicle records
  //   const da = this.daVehicleData.items;       // Vehicle master data
  //   const us = this.userTypeData;              // User type data

  //   // Array to hold the final constructed records
  //   const finalData = [];

  //   // Step 2: Iterate through each assigned car record
  //   for (let i = 0; i < ca.length; i++) {
  //     // Clone the current record to avoid modifying the original
  //     let currentRecord = { ...ca[i] };

  //     // Find the matching vehicle in vh based on car_id
  //     const matchedVehicle = vh.find(vehicle => vehicle.id === currentRecord['car_id']);
  //     if (matchedVehicle) {
  //       // Merge matched vehicle data into the cloned record
  //       currentRecord = { ...currentRecord, ...matchedVehicle };
  //       console.log(`Matched Vehicle for ca[${i}]:`, matchedVehicle);
  //     }

  //     // Step 3: Iterate through vehicle master data to find matches based on veh_reg_id
  //     for (let j = 0; j < da.length; j++) {
  //       // Check if veh_reg_id matches vehicle_no
  //       if (currentRecord['veh_reg_id'] === da[j]['vehicle_no']) {
  //         // Store user_name and user_id from the vehicle data
  //         currentRecord['user_name'] = da[j]['user_name'];
  //         currentRecord['user_rn'] = da[j]['user_id'];
  //         console.log(`Matched Vehicle Data for ca[${i}]:`, da[j]);

  //         // Step 4: Find matching user in us based on driver_id
  //         const matchedDriver = us.find(user => da[j]['driver_id'] === user.id);
  //         if (matchedDriver) {
  //           // Add driver details from the matched user
  //           currentRecord['driver_mobile'] = matchedDriver['user_name'];
  //           currentRecord['driver_name'] = matchedDriver['name'];
  //           console.log(`Matched Driver for ca[${i}]:`, matchedDriver);
  //         }
  //         // Break after matching the first relevant vehicle data
  //         break;
  //       }
  //     }

  //     // Add the modified record to finalData
  //     finalData.push(currentRecord);
  //   }

  //   // Store the final constructed data in receivedAssignVehicleData
  //   console.log('Final_constructed_data:', finalData);
  //   this.receivedAssignVehicleData = finalData;
  // }


  // constructCombinedVehicleData() {
  //   console.log('DA_vehicle_master', this.daVehicleData.items);
  //   console.log('USER_TYPE', this.userTypeData);
  //   const ca = this.cpAssignedCarRecord.filter(record => record.status === 'ASSIGN')
  //   const rc = this.assignedCarData; //data.items;
  //   const da = this.daVehicleData.items;
  //   const us = this.userTypeData;
  //   alert('driver' + this.daVehicleData.items.length)
  //   alert('user' + this.userTypeData.length)

  //   for (let i = 0; i < rc.length; i++) {
  //     for (let j = 0; j < da.length; j++) {
  //       // Checking if vh and da match
  //       if (rc[i]['veh_reg_id'] === da[j]['vehicle_no']) {
  //         // Storing data from da to vh
  //         rc[i]['user_name'] = da[j]['user_name'];
  //         // Custom key-value pair for matching data from da
  //         rc[i]['user_rn'] = da[j]['user_id'];

  //         for (let k = 0; k < us.length; k++) {
  //           // Checking if da and us match
  //           if (da[j]['driver_id'] === us[k]['id']) {
  //             // Storing data from us to vh
  //             rc[i]['driver_mobile'] = us[k]['user_name'];
  //             rc[i]['driver_name'] = us[k]['name'];
  //             // Custom key-value pair for matching data from us
  //             //  data[i]['usName'] = us[k]['da'];
  //           } else {
  //             // If vh and da do not match, continue to the next iteration
  //             continue;
  //           }
  //         }
  //       } else {
  //         // If vh and da do not match, continue to the next iteration
  //         continue;
  //       }
  //       // If vh and da match, break out of the da loop
  //       break;
  //     }
  //   }
  //   console.log('Final_construt', rc);
  //   this.receivedAssignVehicleData = rc;
  // }

  constructCombinedVehicleData() {


    // Filter assigned car records to include only those with status 'ASSIGN'
    const ca = this.assignedCarData.filter(record => record.status === 'ASSIGN');
    const vh = this.receivedAllVehicleRecord; // All vehicle records
    const da = this.daVehicleData.items;      // Vehicle master data
    // const us = this.userTypeRecord;
    // const dt = this.getDriverTypeRecord            // User type data

    // Array to hold the final constructed records
    const finalData = [];

    // Iterate through each filtered car record in ca
    for (let i = 0; i < ca.length; i++) {
      // Clone the current record to avoid modifying the original
      let currentRecord = { ...ca[i] };
      currentRecord['assigned_id'] = ca[i].id;
      // Step 1: Match vehicle data
      currentRecord = this.matchVehicleData(currentRecord, vh);

      // // Step 2: Match user data
      // currentRecord = this.matchUserData(currentRecord, us);

      // // Step 3: Match driver data
      // currentRecord = this.matchDriverData(currentRecord, vh, da, dt);
      if (da.length) {
        currentRecord = this.matchDriverData(currentRecord, vh, da);
      }

      // Add the modified record to finalData
      finalData.push(currentRecord);
    }

    // Store the final constructed data in receivedAssignVehicleData
    this.receivedAssignVehicleData = finalData;

    this.spinnerService.hide();
  }

  // Function to match vehicle data based on car_id and add details to the record
  matchVehicleData(record: any, vehicleRecords: any[]) {
    if (record.user) {
      record['user_name'] = record.user.user_name;
      record['name'] = record.user.name;
    } else {
      record['user_name'] = "";
      record['name'] = "";
    }
    for (let vehicle of vehicleRecords) {
      if (record['car_id'] === vehicle['id']) {
        console.log(vehicle, "vehicle::::::::::::::::::");
        // Merge vehicle data into the record
        return { ...record, ...vehicle }; // Return the updated record
      }
    }
    return record; // Return the original record if no match was found
  }

  // Function to match user data based on user_pid and add details to the record
  matchUserData(record: any, userRecords: any[]) {
    for (let user of userRecords) {
      console.log('user', user)
      if (record['user_pid'] === user['id']) {
        record['user_name'] = user['user_name'];
        record['name'] = user['name'];
        return record; // Return the updated record after matching
      }
    }
    return record; // Return the original record if no match was found
  }


  // Function to match driver data based on vehicle and user details, then add to the record
  // matchDriverData(record: any, vehicleRecords: any[], vehicleMaster: any[], userRecords: any[]) {
  //   for (let vehicle of vehicleRecords) {
  //     if (record['car_id'] === vehicle['id']) {
  //       const vehicleRegId = vehicle['veh_reg_id'];
  //       for (let masterVehicle of vehicleMaster) {
  //         if (vehicleRegId === masterVehicle['vehicle_no']) {
  //           // record['user_name'] = masterVehicle['user_id'];
  //           // record['name'] = masterVehicle['user_name'];
  //           const driverId = masterVehicle['driver_id'];
  //           for (let user of userRecords) {
  //             if (driverId === user['id']) {
  //               record['driver_name'] = user['name'];
  //               record['driver_mobile'] = user['user_name'];
  //               return record; // Return the updated record after matching
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  //   return record; // Return the original record if no match was found
  // }

  matchDriverData(record: any, vehicleRecords: any[], vehicleMaster: any[]) {
    for (let vehicle of vehicleRecords) {
      if (record['car_id'] === vehicle['id']) {
        const vehicleRegId = vehicle['veh_reg_id'];
        for (let masterVehicle of vehicleMaster) {
          if (vehicleRegId === masterVehicle['vehicle_no']) {
            // record['user_name'] = masterVehicle['user_id'];
            // record['name'] = masterVehicle['user_name'];
            record['driver_name'] = masterVehicle["driver"]['name'];
            record['driver_mobile'] = masterVehicle["driver"]['user_name'];
            return record;
          }
        }
      }
    }
    return record; // Return the original record if no match was found
  }

  // // Function to match driver data based on vehicle and user details, then add to the record
  // matchDriverData(record: any, vehicleRecords: any[], vehicleMaster: any[], userRecords: any[]) {
  //   for (let vehicle of vehicleRecords) {
  //     if (record['car_id'] === vehicle['id']) {
  //       const vehicleRegId = vehicle['veh_reg_id'];
  //       for (let masterVehicle of vehicleMaster) {
  //         if (vehicleRegId === masterVehicle['vehicle_no']) {
  //           record['user_name'] = masterVehicle['user_id'];
  //           record['name'] = masterVehicle['user_name'];
  //           const driverId = masterVehicle['driver_id'];
  //           for (let user of userRecords) {
  //             if (driverId === user['id']) {
  //               record['driver_name'] = user['name'];
  //               record['driver_mobile'] = user['user_name'];
  //               return record; // Return the updated record after matching
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  //   // return record; // Return the original record if no match was found
  // }






  // constructCombinedVehicleData() {
  //   console.log('DA_vehicle_master', this.daVehicleData.items);
  //   console.log('USER_TYPE', this.userTypeData);

  //   // Filter to include only records with status 'ASSIGN'
  //   const ca = this.assignedCarData.filter(record => record.status === 'ASSIGN');
  //   const vh = this.receivedAllVehicleRecord; // All vehicle records
  //   const da = this.daVehicleData.items;      // Vehicle master data
  //   const us = this.userTypeData;             // User type data

  //   ca get key value car_id and match the vh key value id and store into ca
  //   ca get key value user_pid and match the us key value id and add two two key user_name & name form userTypeData store into ca 
  //   ca get key value car_id and match the vh key value id get veh_reg_id and match the da key vehicle_no and get driver_id
  //   after the id passing to the us key value id and add two two key drivername & drivermobile form userTypeData store into ca  


  //   these is based on only ca length
  //   // Store the final constructed data in receivedAssignVehicleData
  //   console.log('Final_constructed_data:', vh);
  //   this.receivedAssignVehicleData = vh;
  // }



  // constructCombinedVehicleData() {
  //   console.log('DA_vehicle_master', this.daVehicleData.items);
  //   console.log('USER_TYPE', this.userTypeData);
  //   const ca = this.assignedCarData
  //   const vh = this.receivedAllVehicleRecord; //data.items; 
  //   const da = this.daVehicleData.items;
  //   const us = this.userTypeData;
  //   alert('driver' + this.daVehicleData.items.length)
  //   alert('user' + this.userTypeData.length)



  //   // Array to hold the final constructed records
  //   const finalData = [];

  //   // Iterate through each assigned car record
  //   for (let i = 0; i < ca.length; i++) {
  //     // Clone the current record to avoid modifying the original
  //     let currentRecord = { ...ca[i] };

  //     // Find the matching vehicle in vh based on car_id
  //     const matchedVehicleID = vh.find(vehicle => vehicle.id === currentRecord['car_id']);
  //     if (matchedVehicleID) {
  //       // Merge matched vehicle data into the cloned record
  //       currentRecord = { ...currentRecord, ...matchedVehicleID };
  //       console.log(`Matched Vehicle for ca[${i}]:`, currentRecord);
  //     }
  //     // Find the matching vehicle in vh based on car_id
  //     const matchedUser = us.find(vehicle => vehicle.id === currentRecord['user_pid']);
  //     if (matchedUser) {
  //       // Merge matched vehicle data into the cloned record
  //       currentRecord[i]['user_name'] = us[i]['user_name'];
  //       currentRecord[i]['name'] = us[i]['name'];
  //       currentRecord = { ...currentRecord, ...matchedUser };
  //       console.log(`Matched Vehicle for ca_2[${i}]:`, currentRecord);
  //     }

  //     // Find the matching vehicle in da based on user id
  //     const matchedDriver = da.find(vehicle => vehicle.driver_id === us['id']);
  //     if (matchedDriver) {
  //       // Merge matched vehicle data into the cloned record
  //       currentRecord[i]['driver_mobile'] = us[i]['user_name'];
  //       currentRecord[i]['driver_name'] = us[i]['name'];
  //       currentRecord = { ...currentRecord, ...matchedDriver };
  //       console.log(`Matched Vehicle for ca_2[${i}]:`, currentRecord);
  //     }

  //   }

  //   // for (let i = 0; i < rc.length; i++) {
  //   //   for (let j = 0; j < da.length; j++) {
  //   //     // Checking if vh and da match
  //   //     if (rc[i]['veh_reg_id'] === da[j]['vehicle_no']) {
  //   //       // Storing data from da to vh
  //   //       rc[i]['user_name'] = da[j]['user_name'];
  //   //       // Custom key-value pair for matching data from da
  //   //       rc[i]['user_rn'] = da[j]['user_id'];

  //   //       for (let k = 0; k < us.length; k++) {
  //   //         // Checking if da and us match
  //   //         if (da[j]['driver_id'] === us[k]['id']) {
  //   //           // Storing data from us to vh
  //   //           rc[i]['driver_mobile'] = us[k]['user_name'];
  //   //           rc[i]['driver_name'] = us[k]['name'];
  //   //           // Custom key-value pair for matching data from us
  //   //           //  data[i]['usName'] = us[k]['da'];
  //   //         } else {
  //   //           // If vh and da do not match, continue to the next iteration
  //   //           continue;
  //   //         }
  //   //       }
  //   //     } else {
  //   //       // If vh and da do not match, continue to the next iteration
  //   //       continue;
  //   //     }
  //   //     // If vh and da match, break out of the da loop
  //   //     break;
  //   //   }
  //   // }
  //   // console.log('Final_construt', rc);
  //   // this.receivedAssignVehicleData = rc;


  // }

  // constructCombinedVehicleData() {
  //   console.log('DA_vehicle_master', this.daVehicleData.items);
  //   console.log('USER_TYPE', this.userTypeData);
  //   const ca = this.assignedCarData
  //   const rc = this.receivedAllVehicleRecord; //data.items; 
  //   const da = this.daVehicleData.items;
  //   const us = this.userTypeData;
  //   alert('driver' + this.daVehicleData.items.length)
  //   alert('user' + this.userTypeData.length)

  //   for (let i = 0; i < rc.length; i++) {
  //     for (let j = 0; j < da.length; j++) {
  //       // Checking if vh and da match
  //       if (rc[i]['veh_reg_id'] === da[j]['vehicle_no']) {
  //         // Storing data from da to vh
  //         rc[i]['user_name'] = da[j]['user_name'];
  //         // Custom key-value pair for matching data from da
  //         rc[i]['user_rn'] = da[j]['user_id'];

  //         for (let k = 0; k < us.length; k++) {
  //           // Checking if da and us match
  //           if (da[j]['driver_id'] === us[k]['id']) {
  //             // Storing data from us to vh
  //             rc[i]['driver_mobile'] = us[k]['user_name'];
  //             rc[i]['driver_name'] = us[k]['name'];
  //             // Custom key-value pair for matching data from us
  //             //  data[i]['usName'] = us[k]['da'];
  //           } else {
  //             // If vh and da do not match, continue to the next iteration
  //             continue;
  //           }
  //         }
  //       } else {
  //         // If vh and da do not match, continue to the next iteration
  //         continue;
  //       }
  //       // If vh and da match, break out of the da loop
  //       break;
  //     }
  //   }
  //   console.log('Final_construt', rc);
  //   this.receivedAssignVehicleData = rc;


  // }

  // Toggle the dropdown on button click
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;

    if (this.isDropdownOpen) {
      this.addClickOutsideListener();
    } else {
      this.removeClickOutsideListener();
    }
  }

  // Open the dropdown on hover
  openDropdown(): void {
    this.isDropdownOpen = true;
  }

  // Close the dropdown when the mouse leaves the container
  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  // Add a listener for clicks outside the dropdown
  private addClickOutsideListener(): void {
    this.clickListener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
      if (this.dropdownContainer && !this.dropdownContainer.nativeElement.contains(event.target)) {
        this.isDropdownOpen = false;
        this.removeClickOutsideListener();
      }
    });
  }

  // Remove the outside click listener to prevent memory leaks
  private removeClickOutsideListener(): void {
    if (this.clickListener) {
      this.clickListener();
      this.clickListener = undefined;
    }
  }

  public async downloadExcel(status: any) {
    console.log('downloadExcel-function-trigger')
    let dataSheet: any[] = [];
    let download: any[];
    this.toggleDropdown();
    switch (status) {
      case 'ASSIGN':
        download = this.receivedAssignVehicleData;
        break;
      case 'UNASSIGN':
        download = this.unAssignedCarData
        break;
      case 'VIP':
        download = this.vipData
        break;
      case 'SURRENDER':
        download = this.surrenderedData
        break;
      default:
        download = this.receivedAllVehicleRecord
        break;
    }

    for (const sheet of download) {
      const insuranceStatus = this.stringToDateAndRenewalPipe.transform(sheet.policy_to);
      const leaseStatus = this.stringToDateAndRenewalPipe.transform(sheet.lease_to);

      //     "id": "71b44533-cc1e-4178-80ad-df23119b024b",
      //     "car_model": "Capture",
      //     "veh_reg_id": "TN19AH1562",
      //     "policy_no": "VC673113",
      //     "policy_from": "2024-03-14",
      //     "policy_to": "2025-03-13",
      //     "agency_name": "e11e908e-5064-4550-8023-8c054d472c16",
      //     "map_user_id": "0",
      //     "lease_from": "2018-03-16",
      //     "lease_to": "2024-03-15",
      //     "car_type": "Office",
      //     "ex_data": "ASSIGN",
      //     "car_make": "Renault",
      //     "car_variant": "CAPTUR PLATINE DSL MT MONO",
      //     "car_color": "Red",
      //     "fuel_type": "Diesel",
      //     "car_registration_date": "2018-03-16",
      //     "chasis_number": "MEERHA009J1004260",
      //     "asset_number": "36311 / OG-21-1934-1801-00016896 / OG-22-1934-1801-00016074/OG-23-1934-1801-00013912",
      //     "surrender_date": null,
      //     "created_date": null,
      //     "updated_date": "2024-05-27T17:10:13+05:30",
      //     "vehicle_rc_book_attachments": [
      //         {
      //             "uploaded_on": "2024-05-15T15:06:05.682Z",
      //             "url": "vdms/rcbook/rcbook_TN19AH1562_1715785564029.pdf"
      //         }
      //     ],
      //     "insurance_policy_attachments": [
      //         {
      //             "uploaded_on": "2024-05-27T12:16:32.384Z",
      //             "url": "vdms/insurance/insurance_TN19AH1562_1716812181255.pdf"
      //         }
      //     ],
      //     "vehicle_lease_attachments": []
      // },


      const dataRecord = {
        'Employee ID': sheet.user_rn || '',
        'Employee Name': sheet.user_name || '',
        'Vehicle No': sheet.veh_reg_id,
        Handler: sheet.car_type,
        'Fuel type': sheet.fuel_type,
        Make: sheet.car_make,
        Model: sheet.car_model,
        Fuel: sheet.fuel_type,
        Variant: sheet.car_variant,
        Color: sheet.car_color,
        status: sheet.ex_data,
        'chasis number': sheet.chasis_number,
        'Purchase order number': sheet.po_number,
        'Asset number': sheet.asset_number,
        'Rental month': sheet.rental_month,
        'document code': sheet.document_code,
        'RC Register Date': sheet.car_registration_date,
        'RC attached': sheet.vehicle_rc_book_attachments != null && sheet.vehicle_rc_book_attachments.length > 0 ? 'Yes' : 'No',
        'Policy Number': sheet.policy_no,
        'Policy From': sheet.policy_from,
        'Policy to': sheet.policy_to,
        'Policy status': insuranceStatus.status,
        'Policy attached': sheet.insurance_policy_attachments != null && sheet.insurance_policy_attachments.length > 0 ? 'Yes' : 'No',
        'Lease From': sheet.lease_from,
        'Lease to': sheet.lease_to,
        'lease status': leaseStatus.status,
        'lease attached': sheet.vehicle_lease_attachments != null && sheet.vehicle_lease_attachments.length > 0 ? 'Yes' : 'No',
      };



      dataSheet.push(dataRecord);
    }

    this.excelFileDownloadServices.downloadExcel(dataSheet);
  }


  async viewVehicle(viewData: any, tabName: string) {
    this.viewDetails = viewData;
    this.tabName = tabName;
    console.log(this.viewDetails, "this.viewDetails::::::::::::::::::::::");

    if (tabName == 'Un_assigned' || tabName == 'surrender') {
      try {
        let attach: any = await this.vehicleService.getReturnAttachments({ car_id: this.viewDetails.id });
        // let vehicle_return_attachments = [];
        // attach.items.forEach((item) => {
        //   // Check if vehicle_return_attachments exists and is not an empty array
        //   if (Array.isArray(item.vehicle_return_attachments) && item.vehicle_return_attachments.length > 0) {
        //     vehicle_return_attachments.push(item.vehicle_return_attachments[0]);  // push the first element
        //   }
        // });

        // this.viewDetails["vehicle_return_attachments"] = vehicle_return_attachments;
        this.viewDetails["returnDetails"] = attach.items;

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    const modal = new window.bootstrap.Modal(this.viewModal.nativeElement);
    modal.show();
  }


  rcDownload() {
    const paramURL = this.viewDetails.vehicle_rc_book_attachments;

    if (paramURL && paramURL.length > 0) {
      const url = paramURL[0].url; // Get the URL from the first attachment
      console.log(url); // Output the URL or do something with it
      //  this.generatePreSignedUrl(url)
      this.download(paramURL)
      return url; // Return the URL if needed
    } else {
      console.log("No attachments found.");
      return null; // Handle the case where there are no attachments
    }
  }

  insuranceDownload() {
    const paramURL = this.viewDetails.insurance_policy_attachments;

    if (paramURL && paramURL.length > 0) {
      const url = paramURL[0].url; // Get the URL from the first attachment
      console.log(url); // Output the URL or do something with it
      this.download(paramURL)
      //this.generatePreSignedUrl(url)
      return url; // Return the URL if needed
    } else {
      console.log("No attachments found.");
      return null; // Handle the case where there are no attachments
    }
  }

  leaseDownload() {
    const paramURL = this.viewDetails.vehicle_lease_attachments;

    if (paramURL && paramURL.length > 0) {
      const url = paramURL[0].url; // Get the URL from the first attachment
      console.log(url); // Output the URL or do something with it
      this.download(paramURL)
      //this.generatePreSignedUrl(url)
      return url; // Return the URL if needed
    } else {
      console.log("No attachments found.");
      return null; // Handle the case where there are no attachments
    }
  }


  surrenderDownload() {
    const paramURL = this.viewDetails.surrender_car_attachments;

    if (paramURL && paramURL.length > 0) {
      const url = paramURL[0].url; // Get the URL from the first attachment
      console.log(url); // Output the URL or do something with it
      this.download(paramURL)
      //this.generatePreSignedUrl(url)
      return url; // Return the URL if needed
    } else {
      console.log("No attachments found.");
      return null; // Handle the case where there are no attachments
    }
  }

  returnDownload(files: any) {
    const paramURL = files;
    
    if (paramURL && paramURL.length > 0) {
      const url = paramURL[0].url; // Get the URL from the first attachment
      console.log(url); // Output the URL or do something with it
      this.download(paramURL)
      // this.downloadMultiFile(paramURL)
      //this.generatePreSignedUrl(url)
      return url; // Return the URL if needed
    } else {
      console.log("No attachments found.");
      return null; // Handle the case where there are no attachments
    }
  }

  async downloadMultiFile(data: any) {
    if (data !== null && data !== '') {
      if (data.length > 0) {
        // do something
        data.sort(function compare(a, b) {
          const dateA: any = new Date(a.uploaded_on);
          const dateB: any = new Date(b.uploaded_on);
          return dateB - dateA;
        });
        let urlData = [];
        for (let file of data) {
          console.log(file.url)
          let url = this.getPreSignedUrl(file.url);
          urlData.push(url);
        }
        console.log(urlData, "urlData::::::::::::::::::");

        this.downloadFilesAsZip(urlData);
      }
    }

  }


  private getPreSignedUrl(key: string) {
    const params = {
      Bucket: 'rnconnect-ope',
      Key: key,
      Expires: 3600, // Set the expiration time in seconds (e.g., 1 hour)
    };
    const url = this.awsS3BucketService.getPreSignedUrl(key);
    return url;
  }

  private generatePreSignedUrl(key: string) {
    const params = {
      Bucket: 'rnconnect-ope',
      Key: key,
      Expires: 3600, // Set the expiration time in seconds (e.g., 1 hour)
    };
    const url = this.awsS3BucketService.getPreSignedUrl(key);
    console.log('presignedURL', url);

    this.downloadfile(url)

  }

  async download(data: any) {
    console.log('File_download', data);

    if (data !== null && data !== '') {
      if (data.length > 0) {
        // do something
        data.sort(function compare(a, b) {
          const dateA: any = new Date(a.uploaded_on);
          const dateB: any = new Date(b.uploaded_on);
          return dateB - dateA;
        });
        console.log('find_url', data[0])
        this.generatePreSignedUrl(data[0].url)
        // this.downloadAlertConfirm(key, data[0]);
      }
    } else {
      //this.errorAlertConfirm(key);
    }

    console.log('::OUTPIT', data);
  }

  // // Option 1: Direct URL download
  downloadfile(result) {
    const link = document.createElement("a");
    link.setAttribute("href", result);
    link.setAttribute("download", result);
    // Set the target attribute to open in a new tab
    link.setAttribute("target", "_blank");

    document.body.appendChild(link);
    link.click();

    link.remove();
  }

  async downloadFilesAsZip(urls: string[]) {
    // Create a new instance of JSZip
    const zip = new JSZip();

    try {
      // Fetch the files and add them to the zip
      for (let url of urls) {
        const response = await fetch(url);
        const blob = await response.blob();
        const fileName = url.split('/').pop().split('?')[0]; // Get the file name from URL

        // Add the file to the zip archive
        zip.file(fileName, blob);
      }

      // Generate the ZIP file asynchronously
      const content = await zip.generateAsync({ type: "blob" });

      // Create a link to download the ZIP
      const a = document.createElement("a");
      const zipUrl = URL.createObjectURL(content);
      a.href = zipUrl;
      a.download = "Return_Vehicle_Attachments"; // Default download name
      a.click();

      // Clean up the object URL after downloading
      URL.revokeObjectURL(zipUrl);

    } catch (error) {
      console.error('Error downloading files or creating ZIP:', error);
    }
  }

  file: File;
  statusList = [];
  vendorList = [];
  uploadList = [];
  uploadStatus: number = 0;
  progresspercent: number = 0;
  displayValue: number = 0;
  arrayBuffer: any;
  sheetlength: number = 0;
  cnt: number = 1;
  enableUploadBtn: boolean = false;
  @ViewChild('uploadFile') uploadFile: ElementRef;
  @ViewChild('closeUploadModalBtn') closeuploadModalBtn: ElementRef;

  incomingfile(event) {
    this.uploadStatus = -1;
    this.file = event.target.files[0];
    this.enableUploadBtn = false;
    this.getVendorData();
  }

  async getVendorData() {
    this.vendorList = [];
    const vendorDetails = await this.vendorService.filterByVendor('Car');
    if (vendorDetails) {
      this.vendorList = vendorDetails.items; // Populate the select options
    }
    this.enableUploadBtn = true;
  }



  isInvalid(str) {
    if (str == 'undefined' || str == null || str.length < 1)
      return true;
    else
      return false;
  }

  uploadVehicle() {
    if (this.file == undefined) {
      return;
    }

    this.statusList = [];
    this.uploadList = [];
    this.progresspercent = 0;
    this.uploadStatus = 1;
    this.displayValue = 0;

    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var worksheet = workbook.Sheets["data"];
      var sheet = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      this.sheetlength = sheet.length;
      console.log(sheet, "sheet:::::::::::::::::::;;");
      
      this.startProcess(sheet);
    }
    fileReader.readAsArrayBuffer(this.file);
    this.uploadStatus = 1;
  }

  //After reading insert the record 
  async startProcess(sheet) {
    for (const dict of sheet) {

      var s_no = String(dict["S.No"]).trim();
      var agency_name = String(dict["Agency Name"]).trim();
      var veh_reg_id = String(dict["Vehicle Number"]).trim();
      var car_make = String(dict["Make"]).trim();
      var car_model = String(dict["Model"]).trim();
      var car_variant = String(dict["Varient"]).trim();
      var car_color = String(dict["Color"]).trim();
      var fuel_type = String(dict["Fuel Type"]).trim();
      var car_type = String(dict["Vehicle Type"]).trim();
      var chasis_number = String(dict["Chasis Number"]).trim();
      var po_number = dict["Purchase Order Number"] ? String(dict["Purchase Order Number"]).trim() : "";
      var asset_number = dict["Asset Number"] ? String(dict["Asset Number"]).trim() : "";
      var rental_month = dict["Rental/Month"] ? String(dict["Rental/Month"]).trim() : "";
      var document_code = dict["Document Number"] ? String(dict["Document Number"]).trim() : "";

      const excelDateToJSDate = (serial) => {
        // Excel's base date is 1900-01-01, so we adjust it by subtracting 25569 (Excel to Unix date shift)
        const jsDate = new Date((serial - 25569) * 86400 * 1000); // Convert to JavaScript Date
        
        // Format the date as yyyy-mm-dd
        const formattedDate = jsDate.toISOString().split('T')[0];
        
        return formattedDate;
      }

      const rcdate = excelDateToJSDate(dict['RC Registration Date']);
      var car_registration_date = rcdate;

      var policy_no = dict["Policy Number"] ? String(dict["Policy Number"]).trim() : "";
      const postartdate = excelDateToJSDate(dict["Policy Start Date"]);
      var policy_from = postartdate;
      const poenddate = excelDateToJSDate(dict["Policy End Date"]);
      var policy_to = poenddate;
      const lestartdate = excelDateToJSDate(dict["Lease Start Date"]);
      var lease_from = lestartdate;
      const leenddate = excelDateToJSDate(dict["Lease End Date"]);
      var lease_to = leenddate;

      var carData = {
        agency_name: agency_name,
        veh_reg_id: veh_reg_id,
        car_make: car_make,
        car_model: car_model,
        car_variant: car_variant,
        car_color: car_color,
        fuel_type: fuel_type,
        car_type: car_type,
        chasis_number: chasis_number,
        po_number: po_number,
        asset_number: asset_number,
        rental_month: rental_month,
        document_code: document_code,
        car_registration_date: car_registration_date,
        policy_no: policy_no,
        policy_from: policy_from,
        policy_to: policy_to,
        lease_from: lease_from,
        lease_to: lease_to,
      }

      console.log(carData);
      

      var errorText = ""

      if (this.isInvalid(carData.veh_reg_id)) {
        errorText = errorText + 'Invalid Vehicle Number :: '
      }
      if (this.isInvalid(carData.car_make)) {
        errorText = errorText + 'Invalid Make :: '
      }

      if (this.isInvalid(carData.car_model)) {
        errorText = errorText + 'Invalid Car Modal :: '
      }

      if (this.isInvalid(carData.car_variant)) {
        errorText = errorText + 'Invalid Car Variant :: '
      }
      
      if (this.isInvalid(carData.car_color)) {
        errorText = errorText + 'Invalid Car Color :: '
      }


      const checkInvalidChasisNumber = (value) => {
        // Check if the value is defined and exactly 16 characters long
        if (!value || value.length !== 17) {
          return { invalidChassisNumber: true }; // Handle invalid length
        }

        // Check if the value contains only alphanumeric characters
        const isAlphanumeric = /^[a-zA-Z0-9]*$/.test(value); // Check for only alphanumeric characters

        // Check for at least one letter and one number
        const hasLetter = /[a-zA-Z]/.test(value); // Check for at least one letter
        const hasNumber = /[0-9]/.test(value); // Check for at least one number

        // Return error if it fails any of the conditions
        if (!isAlphanumeric || !hasLetter || !hasNumber) {
          return { invalidChassisNumber: true }; // Return an error object
        }

        return { invalidChassisNumber: false }
      }

      if (this.isInvalid(carData.chasis_number) || checkInvalidChasisNumber(carData.chasis_number).invalidChassisNumber) {
        errorText = errorText + 'Invalid Chasis Number :: '
      }


      if (carData.policy_from) {
        var dateSplitArr = carData.policy_from.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Policy From Date :: '
        }
      }
      
      if (carData.policy_to) {
        var dateSplitArr = carData.policy_to.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Policy End Date :: '
        }
      }


      if (carData.lease_from) {
        var dateSplitArr = carData.lease_from.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Lease Start Date :: '
        }
      }

      if (carData.lease_to) {
        var dateSplitArr = carData.lease_to.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Lease End Date :: '
        }
      }

      if (this.isInvalid(carData.agency_name)) {
        errorText = errorText + 'Invalid Agency Name :: '
      } else {
        var isVendorAvailable = false;
        for (var i = 0; i < this.vendorList.length; i++) {
          if (carData.agency_name === this.vendorList[i].name) {
            carData.agency_name = this.vendorList[i].id
            isVendorAvailable = true;
          }
        }
        if (!isVendorAvailable) {
          errorText = errorText + 'Invalid Vendor Name - Not Found :: '
        }
      }

      if (this.isInvalid(carData.fuel_type)) {
        errorText = errorText + 'Invalid Fuel Type :: '
      } else {
        if (carData.fuel_type.toLowerCase().includes("petrol")) {
          carData.fuel_type = 'Petrol'
        } else if (carData.fuel_type.toLowerCase().includes("diesel")) {
          carData.fuel_type = 'Diesel'
        } else if (carData.fuel_type.toLowerCase().includes("electric")) {
          carData.fuel_type = 'Electric'
        } else {
          errorText = errorText + 'Invalid Fuel Type - ' + carData.fuel_type + ' :: '
        }
      }

      if (this.isInvalid(carData.car_type)) {
        errorText = errorText + 'Invalid Car Type :: '
      } else {
        if (carData.car_type.toLowerCase().includes("office")) {
          carData.car_type = 'Office'
        } else if (carData.car_type.toLowerCase().includes("family")) {
          carData.car_type = 'Family'
        } else if (carData.car_type.toLowerCase().includes("vip")) {
          carData.car_type = 'VIP'
        } else if (carData.car_type.toLowerCase().includes("admin")) {
          carData.car_type = 'Admin'
        } else {
          errorText = errorText + 'Invalid Car Type - ' + carData.car_type + ' :: '
        }
      }

      if (errorText.length > 0) {
        // console.log("----------" + errorText)
        this.statusList.push({ line_no: s_no, status: 'Error', error: errorText });
        this.displayValue = 1;
        this.uploadStatus = 3;
      } else {
        this.uploadList.push(carData)
        this.progressIncrement();
      }

    }

    console.log(this.uploadList);
    


    if (this.statusList.length == 0 && this.uploadList.length > 0) {
      // console.log('inside if');
      for (var i = 0; i < this.uploadList.length; i++) {
        var item = this.uploadList[i];
        this.OnSaveVehicle(item, i);
      }
    }
  }

  closeModal() {
    this.closeuploadModalBtn.nativeElement.click();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  async OnSaveVehicle(value, i) {
    await this.vehicleService.createVehicleMaster(value);
    if(i== this.uploadList.length-1) {
      this.closeModal();
    }
  }

  progressIncrement() {
    if (this.cnt == this.sheetlength) {
      this.uploadStatus = 2;
    }

    this.progresspercent = this.cnt * 50 / this.sheetlength;
    this.cnt++;
  }

  resetFile() {
    this.uploadFile.nativeElement.value = null;
    this.file = undefined;
    this.enableUploadBtn = false;
    this.uploadStatus = 0;
  }

}
